export default __webpack_public_path__ + "static/media/referFriendInfoEng.e9dfa461.svg";